const BaseCheckIcon = (props) => (
  <svg width="12" height="9" viewBox="0 0 12 9" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.66845 7.11463L10.7964 0.985962L11.7398 1.92863L4.66845 8.99996L0.425781 4.7573L1.36845 3.81463L4.66845 7.11463Z" />
  </svg>
);

export default BaseCheckIcon;
